import blue from '@/themes/blue.js'
import carbon from '@/themes/carbon.js'
import d from '@/themes/default.js'
import green from '@/themes/green.js'
import red from '@/themes/red.js'

export default {
		'blue': blue,
		'carbon': carbon,
		'default': d,
		'green': green,
		'red': red
};